import type { LosType } from '../types';

export const LOS_FIELDS: Record<LosType, { key: string; label: string; masked?: boolean }[]> = {
  encompass: [
    { key: 'instanceId', label: 'Instance ID' },
    { key: 'clientId', label: 'Client ID' },
    { key: 'clientSecret', label: 'Client Secret', masked: true },
    { key: 'floodServiceId', label: 'Flood Service ID' },
    { key: 'titleServiceId', label: 'Title Service ID' },
    { key: 'valuationServiceId', label: 'Valuation Service ID' },
  ],
  'ml-consumer': [
    { key: 'baseApiUrl', label: 'URL' },
    { key: 'apiUsername', label: 'API Username' },
    { key: 'apiPassword', label: 'API Password', masked: true },
    { key: 'apiToken', label: 'API Token', masked: true },
    { key: 'lenderCode', label: 'Lender Code' },
  ],
  'ml-mortgage': [
    { key: 'apiUsername', label: 'API Username' },
    { key: 'apiPassword', label: 'API Password', masked: true },
    { key: 'apiToken', label: 'API Token', masked: true },
    { key: 'lenderCode', label: 'Lender Code' },
  ],
};

/** The Encompass Service Setup IDs render in their own section, apart from the credentials. */
export const ENCOMPASS_SERVICE_SETUP_KEYS = ['floodServiceId', 'titleServiceId', 'valuationServiceId'];
